import { IntegrationControllerBaseConfig } from '../../../base';
import { ThreadUpsertController } from './integrationUpsertInterface';
import {
    ThreadUpsertControllerProps,
    ThreadUpsertViewProps,
} from './integrationUpsertProps';

export function createThreadUpsertController(
    config: IntegrationControllerBaseConfig
): ThreadUpsertController {
    return {
        useProps(context, data, props): ThreadUpsertViewProps {
            if (data.thread) {
                // Thread exists, show detail view
                return {
                    view: {
                        kind: 'detail',
                        item: { id: data.thread.id },
                    },
                };
            } else {
                // No thread exists, show new view
                return {
                    view: {
                        kind: 'new',
                        integration: data.integration,
                    },
                };
            }
        },
    };
}
